
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'gradebook/outcome-gradebook-cell';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <span class=\"outcome-description\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <span class=\"outcome-score\">"
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.score), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.score), options)))
    + "</span> /"
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.masteryScore), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.masteryScore), options)))
    + "\n  ";
  return buffer;
  }

  buffer += "<div class=\"outcome-cell-wrapper\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.description), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    <span class=\"outcome-result ";
  if (helper = helpers.className) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.className); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" style=\"";
  if (helper = helpers.color) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.color); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></span>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  